import axios from 'axios'

const mensajesleechero = {
    PostGuardar: (datos) => axios.post(`x-parametros/guardar-parametros`,datos),
    GetMensajes: (params) => axios.get(`x-parametros/get_parametros_por_tipos`,{params}),  
}
export default mensajesleechero